import { connect } from "react-redux";
import GoLiveSites from "./goLiveSites";
import { bindActionCreators } from "redux";
import { fetchGoLiveSites, getGOLiveFilterDropDown } from "services/redux/maintenance/goLiveSite/action";

const mapStateToProps = (state) => ({
  liveSiteData: state.liveSiteDataReducer.liveSiteData,
  liveFilterDropDown: state.liveSiteDataReducer.liveFilterDropDown
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchGoLiveSites,
      getGOLiveFilterDropDown
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(GoLiveSites);
